import type { ReactNode } from 'react';
import React from 'react';
import { BrowserRouter as Router, Link, Route } from 'react-router-dom';

import { Logo, Tab, Tabs } from '@feathr/components';

import DataRetention from './Articles/DataRetention';
import FAQ from './Articles/FAQ';

import '@mantine/core/styles.css';
import * as styles from './App.css';

function App(): ReactNode {
  return (
    <Router>
      <div className={styles.header}>
        <Link to={'/'}>
          <Logo theme={'light'} />
          Privacy
        </Link>
      </div>
      <Tabs>
        <Tab className={styles.tab} exact={true} link={'/'} title={'FAQ'} />
        <Tab
          className={styles.tab}
          link={'/data-retention-policy'}
          title={'Data Retention Policy'}
        />
      </Tabs>
      <main>
        <Route exact={true} path={'/'}>
          <FAQ />
        </Route>
        <Route exact={true} path={'/data-retention-policy'}>
          <DataRetention />
        </Route>
      </main>
    </Router>
  );
}

export default App;
